import React from "react";
import { connect } from "react-redux";
import { reduxForm, change } from "redux-form";
import { Link } from "react-router-dom";

import "./Settings.css"

import history from "../../../../history";
import { getSettings, editSettings } from "../../../../actions/settingsActions";

import Form from "../../../CustomViews/Form";

const SettingsForm = reduxForm({ form: "settingsForm" })(Form);

class Settings extends React.Component {
    componentDidMount() {
        this.props.getSettings();
    }

    componentDidUpdate() {
        if (this.props.settings.minCarry) {
            this.props.change("settingsForm", "minCarry", this.props.settings.minCarry);
            this.props.change("settingsForm", "maxCarry", this.props.settings.maxCarry);
            this.props.change("settingsForm", "carryThreshold", this.props.settings.carryThreshold);
        }
    }

    onSubmit = (formValues, onFormError) => this.props.editSettings(formValues, () => history.go(0), onFormError);

    render() {
        return (
            <React.Fragment>
                <div className="settings-component ui container">
                    <div className="ui three item menu">
                        <Link to="/structure" className="item">
                            <div className="content">Struktura firmy</div>
                        </Link>
                        <Link to="/absence/reasons" className="item">
                            <div className="content">Przyczyny absencji</div>
                        </Link>
                        <Link to="/settings" className="active item">
                            <div className="content">Pozostałe ustawienia</div>
                        </Link>
                    </div>
                    <div className="ui divider" />
                    <div className="ui container">
                        <div className="ui large header">
                            <div className="content">Pozostałe ustawienia</div>
                        </div>
                        <SettingsForm onSubmit={this.onSubmit} label="Zapisz" fields={[
                            { name: "minCarry", type: "number", label: "Minimalna liczba przenoszonych nadgodzin", placeholder: "Wpisz wartość...", autofocus: true },
                            { name: "maxCarry", type: "number", label: "Maksymalna liczba przenoszonych nadgodzin", placeholder: "Wpisz wartość..." },
                            { name: "carryThreshold", type: "number", label: "Liczba nadgodzin niepodlegająca przeniesieniu", placeholder: "Wpisz wartość..." }
                        ]} />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    currentUser: state.user.current,
    settings: state.settings
});

export default connect(mapStateToProps, { getSettings, editSettings, change })(Settings);